import React from 'react';
import { Container, Grid, Typography, SvgIcon } from '@mui/material';

const features = [
  {
    title: 'Data-Driven',
    path: 'M3 9h18v2H3V9zm0 4h18v2H3v-2zm0 4h18v2H3v-2z',
  },
  {
    title: 'Fast Iterations',
    path: 'M13 2L3 14h9v8l10-12h-9z',
  },
  {
    title: 'Ethical AI',
    path: 'M12 2l9 4v6c0 5-3.74 10-9 12-5.26-2-9-7-9-12V6l9-4z',
  },
  {
    title: 'End-to-End Delivery',
    path: 'M9 16.2l-3.5-3.5L4 14l5 5 10-10-1.4-1.4z',
  },
];

export default function FeatureIcons() {
  return (
    <Container sx={{ py: 8, color: 'common.white' }}>
      <Grid container spacing={4} justifyContent="center">
        {features.map((feature) => (
          <Grid item xs={6} md={3} key={feature.title} textAlign="center">
            <Typography variant="h6" component="h3" gutterBottom>
              {feature.title}
            </Typography>
            <SvgIcon
              sx={{ fontSize: 64, color: 'secondary.main' }}
              viewBox="0 0 24 24"
            >
              <path d={feature.path} />
            </SvgIcon>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
